module.exports = __webpack_public_path__ + "static/media/popup_avatar.49266c51.svg";